// src/components/UpdateNotification.js
import { useState, useEffect } from 'react';
import './UpdateNotification.css';

const UpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [newWorker, setNewWorker] = useState(null);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.addEventListener('updatefound', () => {
          const installingWorker = registration.installing;
          setNewWorker(installingWorker);
          
          installingWorker.addEventListener('statechange', () => {
            if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
              setShowUpdate(true);
            }
          });
        });
      });
    }
  }, []);

  const handleUpdate = () => {
    if (newWorker) {
      newWorker.postMessage({ type: 'SKIP_WAITING' });
      setShowUpdate(false);
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    setShowUpdate(false);
  };

  if (!showUpdate) return null;

  return (
    <div className="update-notification">
      <div className="update-content">
        <h3>نسخه جدید موجود است! 🎉</h3>
        <p>می‌خواهید اپلیکیشن را به‌روزرسانی کنید؟</p>
        <div className="update-buttons">
          <button onClick={handleUpdate} className="update-btn">
            به‌روزرسانی
          </button>
          <button onClick={handleDismiss} className="dismiss-btn">
            بعداً
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;